<div class="izzy-profile-overlay" *ngIf="visible">
  <div class="izzy-profile-modal" role="dialog" aria-modal="true" aria-labelledby="izzy-profile-title">
    <h2 id="izzy-profile-title">Complete your profile</h2>
    <p class="izzy-profile-subtitle">Tell us your name so we can personalize your experience.</p>

    <label for="izzy-profile-first">First name</label>
    <input
      id="izzy-profile-first"
      type="text"
      [(ngModel)]="firstName"
      [disabled]="isSaving"
      placeholder="First name"
      autocomplete="given-name" />

    <label for="izzy-profile-last">Last name</label>
    <input
      id="izzy-profile-last"
      type="text"
      [(ngModel)]="lastName"
      [disabled]="isSaving"
      placeholder="Last name"
      autocomplete="family-name" />

    <div class="izzy-profile-error" *ngIf="errorMessage">{{ errorMessage }}</div>

    <button class="izzy-profile-save" (click)="save()" [disabled]="isSaving">
      {{ isSaving ? 'Saving…' : 'Save and continue' }}
    </button>
  </div>
</div>
